// Получить timezone браузера
export const getBrowserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Конвертировать время слота из timezone специалиста в timezone пользователя
export const convertSlotTime = (
  date: string,        // "2026-03-01"
  time: string,        // "1970-01-01T10:00:00.000Z" или "10:00"
  fromTimezone: string, // "Europe/Moscow"
  toTimezone: string,   // "Asia/Irkutsk"
): string => {
  // Извлекаем HH:MM из time
  let hhmm: string;
  if (time.includes('T')) {
    const d = new Date(time);
    hhmm = `${d.getUTCHours().toString().padStart(2,'0')}:${d.getUTCMinutes().toString().padStart(2,'0')}`;
  } else {
    hhmm = time.slice(0, 5);
  }

  // Создаём datetime в timezone специалиста
  const dtStr = `${date}T${hhmm}:00`;
  const dt = new Date(new Date(dtStr).toLocaleString('en-US', { timeZone: fromTimezone }));
  const utcMs = new Date(dtStr).getTime() + (dt.getTime() - new Date(new Date(dtStr).toLocaleString('en-US', { timeZone: 'UTC' })).getTime());

  // Форматируем в timezone пользователя
  return new Date(dtStr).toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: toTimezone,
  });
};

// Правильная конвертация через Intl
export const convertTime = (
  date: string,
  time: string,
  specialistTimezone: string,
  viewerTimezone: string,
): { time: string; sameDay: boolean } => {
  let hhmm: string;
  if (time.includes('T')) {
    const d = new Date(time);
    hhmm = `${d.getUTCHours().toString().padStart(2,'0')}:${d.getUTCMinutes().toString().padStart(2,'0')}`;
  } else {
    hhmm = time.slice(0, 5);
  }

  // Интерпретируем время как локальное время специалиста
  const [year, month, day] = date.split('T')[0].split('-').map(Number);
  const [hour, minute] = hhmm.split(':').map(Number);

  // Получаем UTC offset для timezone специалиста в эту дату
  const specDate = new Date(year, month - 1, day, hour, minute);
  const specStr = specDate.toLocaleString('en-US', { timeZone: specialistTimezone, hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

  // Парсим обратно
  const [datePart, timePart] = specStr.split(', ');
  const [m, d2, y] = datePart.split('/');
  const [h, min] = timePart.split(':');
  const specUTC = new Date(Date.UTC(Number(y), Number(m)-1, Number(d2), Number(h) % 24, Number(min)));
  const diffMs = specDate.getTime() - specUTC.getTime();
  const utcMs = specDate.getTime() + diffMs;
  const utcDate = new Date(utcMs);

  const resultTime = utcDate.toLocaleTimeString('ru-RU', {
    hour: '2-digit', minute: '2-digit', timeZone: viewerTimezone,
  });

  // Проверяем не перешли ли в другой день
  const resultDate = utcDate.toLocaleDateString('ru-RU', { timeZone: viewerTimezone });
  const origDate = new Date(year, month-1, day).toLocaleDateString('ru-RU');
  const sameDay = resultDate === origDate;

  return { time: resultTime, sameDay };
};

// Список популярных timezone для России и СНГ
export const TIMEZONES = [
  { label: 'Калининград (UTC+2)', value: 'Europe/Kaliningrad' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Самара (UTC+4)', value: 'Europe/Samara' },
  { label: 'Екатеринбург (UTC+5)', value: 'Asia/Yekaterinburg' },
  { label: 'Омск (UTC+6)', value: 'Asia/Omsk' },
  { label: 'Красноярск (UTC+7)', value: 'Asia/Krasnoyarsk' },
  { label: 'Иркутск (UTC+8)', value: 'Asia/Irkutsk' },
  { label: 'Якутск (UTC+9)', value: 'Asia/Yakutsk' },
  { label: 'Владивосток (UTC+10)', value: 'Asia/Vladivostok' },
  { label: 'Магадан (UTC+11)', value: 'Asia/Magadan' },
  { label: 'Камчатка (UTC+12)', value: 'Asia/Kamchatka' },
];
